import React, { Component } from 'react';
import { connect } from 'react-redux';
import { couponActions } from '../../../../store/modules/coupon';
import withModal from '../../../../lib/hoc/withModal';
import ExcelUploadCouponBrandValidSuccessModal from '../../../../views/coupon/common/modal/ExcelUploadCouponBrandValidSuccessModal';
import { syncBrandItemsToZustand } from '../../../../store/couponFormStore';

class ExcelUploadCouponBrandValidSuccessModalContainer extends Component {
  /**
   *  업로드하기
   */
  onSubmit = () => {
    const { data, setCouponBrandItemListExcelUpload } = this.props;
    const { brandList } = data;

    setCouponBrandItemListExcelUpload({
      brandList,
    });

    syncBrandItemsToZustand(brandList);

    this.closeModal();
  };

  /**
   *  모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelUploadCouponBrandValidSuccessModal',
      value: false,
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <ExcelUploadCouponBrandValidSuccessModal
        isOpen={isOpen}
        data={data}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.excelUploadCouponBrandValidSuccessModal.isOpen,
    data: state.coupon.excelUploadCouponBrandValidSuccessModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: couponActions.toggleModal,
  setCouponBrandItemListExcelUpload: couponActions.setCouponBrandItemListExcelUpload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(ExcelUploadCouponBrandValidSuccessModalContainer));
